import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Label, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Loader from "../../../Components/Common/Loader";
import Error from "../../../Components/Common/Error";
import { getClientDetails } from "../../../slices/ManageClient/thunk";
import demoUserImg from "../../../assets/images/users/user-dummy-img.jpg";

export default function ViewClient() {

    const { id } = useParams();
    const SERVER_URL = process.env.REACT_APP_API_IMAGE_URL;

    // Get Client Details
    const dispatch = useDispatch();
    const { isLoading, isError, clientDetails } = useSelector(state => state.GetClientDetails);

    useEffect(() => {
        dispatch(getClientDetails(id));
    }, [dispatch]);

    if (isLoading) return <Loader />

    if (isError) return <Error />

    return (
        <>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={'View Client'} pageTitle={"Dashboard"} />

                    <Row>

                        <Col lg={8} className='pe-1'>

                            <Row>
                                <Col lg={6} className='pe-1 ps-1'>
                                    <Card className="mb-3 card-animate" style={{ borderBottom: '2px solid #015fbb' }}>
                                        <CardHeader className='fw-medium fs-5 p-2 d-flex justify-content-between align-items-center'>
                                            <div>Company Info</div>
                                        </CardHeader>
                                        <CardBody>
                                            <div className="table-card">
                                                <table className="table mb-0">
                                                    <tbody>
                                                        <tr>
                                                            <td className="fw-medium">Company Name</td>
                                                            <td>
                                                                <div className='d-flex'>
                                                                    <div className='position-relative'>
                                                                        {
                                                                            clientDetails.file === "" ?
                                                                                <div className="avatar-md mt-3">
                                                                                    <div className="avatar-title rounded bg-info-subtle text-info fs-16 material-shadow">
                                                                                        CL
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                <img
                                                                                    className="me-3 avatar-md"
                                                                                    src={SERVER_URL + clientDetails.file}
                                                                                    alt="...."
                                                                                    onError={(e) => e.target.src = demoUserImg}
                                                                                    style={{ border: '1px solid #000' }}
                                                                                />
                                                                        }
                                                                    </div>
                                                                    {clientDetails.companyName}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Address</td>
                                                            <td>{clientDetails.address}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Contact No</td>
                                                            <td>{clientDetails.contactNumber}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Email</td>
                                                            <td><span className="text-danger fs-12">{clientDetails.email}</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">City</td>
                                                            <td>{clientDetails.city}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">State</td>
                                                            <td>{clientDetails.state}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Country</td>
                                                            <td>{clientDetails.country}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Zip Code</td>
                                                            <td>{clientDetails.zipCode}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Company URL</td>
                                                            <td><Link target='_blank' to={`${clientDetails.companyUrl}`}>{clientDetails.companyUrl}</Link></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>

                                <Col lg={6} className='ps-1'>
                                    <Card className="mb-3 card-animate" style={{ borderBottom: '2px solid #015fbb' }}>
                                        <CardHeader className='fw-medium fs-5 p-2 d-flex justify-content-between align-items-center'>
                                            <div>Merchant Business </div>

                                        </CardHeader>
                                        <CardBody>
                                            <div className="text-dark">
                                                <ul className="list-unstyled vstack gap-2 mb-0">
                                                    <li>
                                                        <div className="form-check ps-0 d-flex align-items-center">
                                                            {
                                                                clientDetails.retailer === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                            }
                                                            <Label className="form-check-label">
                                                                Retailer
                                                            </Label>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="form-check ps-0 d-flex align-items-center">
                                                            {
                                                                clientDetails.eCommerce === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                            }
                                                            <Label className="form-check-label">
                                                                E-Commerce
                                                            </Label>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="form-check ps-0 d-flex align-items-center">
                                                            {
                                                                clientDetails.telecommunication === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                            }
                                                            <Label className="form-check-label">
                                                                Telecommunication
                                                            </Label>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="form-check ps-0 d-flex align-items-center">
                                                            {
                                                                clientDetails.mailTelephoneOrder === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                            }
                                                            <Label className="form-check-label">
                                                                Mail-Telephone Order
                                                            </Label>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="form-check ps-0 d-flex align-items-center">
                                                            {
                                                                clientDetails.grocerySupermarket === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                            }
                                                            <Label className="form-check-label">
                                                                Grocery & Supermarket
                                                            </Label>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="form-check ps-0 d-flex align-items-center">
                                                            {
                                                                clientDetails.travelEntertainment === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                            }
                                                            <Label className="form-check-label">
                                                                Travel & Entertainment
                                                            </Label>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="form-check ps-0 d-flex align-items-center">
                                                            {
                                                                clientDetails.petroleum === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                            }
                                                            <Label className="form-check-label">
                                                                Petroleum
                                                            </Label>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <h6 className="mb-1 fw-semibold text-uppercase">Other</h6>
                                                        <p className='mb-0'>{clientDetails.otherMerchantBusiness}</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>

                                <Col lg={6} className="ps-1 pe-1">
                                    <Card className="mb-3 card-animate" style={{ borderBottom: '2px solid #015fbb' }}>
                                        <CardHeader className='fw-medium fs-5 p-2 d-flex justify-content-between align-items-center'>
                                            <div>Payment Info</div>
                                        </CardHeader>
                                        <CardBody>
                                            <div className="table-card">
                                                <table className="table mb-0">
                                                    <tbody>
                                                        <tr>
                                                            <td className="fw-medium">Payment Application In Use</td>
                                                            <td><span className="badge bg-success-subtle text-success fs-11">{clientDetails.paymentApplicationInUse}</span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-medium">Payment Application Version</td>
                                                            <td><span className="badge bg-danger-subtle text-danger fs-11">{clientDetails.paymentApplicationVersion}</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>

                        </Col>

                        <Col lg={4} className='ps-1'>
                            <Card className='mb-0 card-animate' style={{ borderBottom: '2px solid #015fbb' }}>
                                <CardHeader className='fw-medium fs-5 p-2 d-flex justify-content-between align-items-center'>
                                    <div>Services Provider Business </div>
                                </CardHeader>
                                <CardBody>
                                    <div className="text-dark">
                                        <ul className="list-unstyled vstack gap-2 mb-0">
                                            <li>
                                                <div className="form-check ps-0 d-flex align-items-center">
                                                    {
                                                        clientDetails.authorization === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                    }
                                                    <Label className="form-check-label">
                                                        Authorization
                                                    </Label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-check ps-0 d-flex align-items-center">
                                                    {
                                                        clientDetails.loyaltyPrograms === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                    }
                                                    <Label className="form-check-label">
                                                        Loyalty Programs
                                                    </Label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-check ps-0 d-flex align-items-center">
                                                    {
                                                        clientDetails.switching === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                    }
                                                    <Label className="form-check-label">
                                                        Switching
                                                    </Label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-check ps-0 d-flex align-items-center">
                                                    {
                                                        clientDetails.d3SecureAccessControlServer === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                    }
                                                    <Label className="form-check-label">
                                                        3D Secure Access Control Server
                                                    </Label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-check ps-0 d-flex align-items-center">
                                                    {
                                                        clientDetails.ipspECommerce === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                    }
                                                    <Label className="form-check-label">
                                                        IPSP (E-Commerce)
                                                    </Label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-check ps-0 d-flex align-items-center">
                                                    {
                                                        clientDetails.processMagneticStripeTransactions === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                    }
                                                    <Label className="form-check-label">
                                                        Process Magnetic Stripe Transactions
                                                    </Label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-check ps-0 d-flex align-items-center">
                                                    {
                                                        clientDetails.paymentGateway === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                    }
                                                    <Label className="form-check-label">
                                                        Payment Gateway
                                                    </Label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-check ps-0 d-flex align-items-center">
                                                    {
                                                        clientDetails.clearingSettlement === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                    }
                                                    <Label className="form-check-label">
                                                        Clearing & Settlement
                                                    </Label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-check ps-0 d-flex align-items-center">
                                                    {
                                                        clientDetails.hosting === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                    }
                                                    <Label className="form-check-label">
                                                        Hosting
                                                    </Label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-check ps-0 d-flex align-items-center">
                                                    {
                                                        clientDetails.processMOTOTransactions === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                    }
                                                    <Label className="form-check-label">
                                                        Process MO/TO Transactions
                                                    </Label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="form-check ps-0 d-flex align-items-center">
                                                    {
                                                        clientDetails.issuingProcessing === true ? <i className="ri-check-double-line fs-4 me-2"></i> : <i className="ri-close-line fs-4 me-2"></i>
                                                    }
                                                    <Label className="form-check-label">
                                                        Issuing / Processing
                                                    </Label>
                                                </div>
                                            </li>
                                            <li>
                                                <h6 className="mb-1 fw-semibold text-uppercase">Other</h6>
                                                <p className='mb-0'>{clientDetails.otherserviceProviderBusiness}</p>
                                            </li>
                                        </ul>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                    </Row>

                </Container>
            </div>
        </>
    )
}